<template>
  <Lists />
</template>

<script>
import Lists from '../../components/list'
export default {
  components: {
    Lists,
  },
}
</script>

<style scoped lang="scss">
</style>